export default [
  {
    path: '/companies',
    meta: {
      auth: true,
    },
    component: () => import('~/common/layouts/default.vue'),
    children: [
      {
        path: '/company/account/:id',
        name: 'companyAccount',
        component: () => import('~/companies/pages/Account.vue'),
        props(route) {
          let props = { ...route.params };
          return props;
        },
      },
    ],
  },
];
